import React, { useEffect, useState } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './productDetail.css';
import mainImage from '../images/main-image.jpg'; 
import thumbImg1 from '../images/thumb-img-1.jpg';
import thumbImg2 from '../images/thumb-img-2.jpg';
import thumbImg3 from '../images/thumb-img-3.jpg';
import thumbImg4 from '../images/thumb-img-4.jpg';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

export const Productdetail = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [loading , setLoading] = useState(false);

  //naviagte hook
  const navigate = useNavigate(); 
  
  function navigateHome() {
    navigate('/' );
  }

  function navigateBack() {
    navigate(-1,{ replace: true });
  }

  function navigateNext() {
    navigate(+1);
  }

  const params = useParams();
 console.log(params);
 const FetchData =  async ()=>{
  setLoading(true);
  try {
    const response =  await axios.get(`https://fakestoreapi.com/products/${params.id}`)
    setData(response.data);
    console.log(response.data);
    setLoading(false);
    
  } catch (error) {
    setError(error.message);
    
  }

 }
 useEffect(()=>{
  FetchData();
 },[]);

 if (error) return <div>Error: {error}</div>;

  
 
  return (
    <>
    <div className="product-container">
      <div className="image-gallery">
        <div className="main-image">
        {loading ? (
        <span class="loader"></span>
      ) : (
        <img src={`${data.image}`} alt="Main Product" />
      )}
          
        </div>
        <div className="thumbnail-image">
          <img src={thumbImg1} alt="Thumbnail 1" />
          <img src={thumbImg2} alt="Thumbnail 2" />
          <img src={thumbImg3} alt="Thumbnail 3" />
          <img src={thumbImg4} alt="Thumbnail 4" />
        </div>
      </div>
      <div className="product-details">
        <h1>{data?.title}</h1>
        <p> { data?.description}</p>
        <div className="rating-price">
          <span>
            <i className="fa fa-star"></i>
          </span>
          <span>
            <i className="fa  fa-star"></i>
          </span>
          <span>
            <i className="fa fa-star"></i>
          </span>
          <span>
            <i className="fa fa-star"></i>
          </span>
          <span>
          <FontAwesomeIcon icon="fa-solid fa-star-half-stroke" style={{color: "#FFD43B",}} />
          </span>
          {/* optional chaining */}
          <span className="rating-value">{data?.rating?.rate}</span> 
          <p className="price"> Rs. {data?.price}  </p>
        </div>
        <div className="size-color">
          <div className="size">
            <p>Available size</p>
            <button className="size-btn">S</button>
            <button className="size-btn">M</button>
            <button className="size-btn">L</button>
          </div>
          <div className="color">
            <p>Available Color</p>
            <div className="color-choose">
              <div>
                <input data-image="red" type="radio" id="red" name="color" value="red" defaultChecked />
                <label htmlFor="red"><span></span></label>
              </div>
              <div>
                <input data-image="blue" type="radio" id="blue" name="color" value="blue" />
                <label htmlFor="blue"><span></span></label>
              </div>
              <div>
                <input data-image="black" type="radio" id="black" name="color" value="black" />
                <label htmlFor="black"><span></span></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='navigate-Btn'>
      <button className='navigate-Btn back' onClick={navigateBack}>Back</button>
      <button className='navigate-Btn home' onClick={navigateHome}> Home Page</button>
      <button className='navigate-Btn next' onClick={navigateNext}> Next</button>
    </div>
    </>
  );
}
